var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-4 mb-2" }, [
          _c(
            "label",
            {
              staticClass: "control-label",
              attrs: { for: _vm.idPrefix + "name" }
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.resource(
                      "DivisionMiscellaneousFieldEditModel_Name_DisplayName"
                    )
                  ) +
                  "\n                "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-8 mb-2" },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.field.name,
                  expression: "field.name"
                }
              ],
              staticClass: "form-control",
              attrs: {
                id: _vm.idPrefix + "name",
                type: "text",
                maxlength: "50"
              },
              domProps: { value: _vm.field.name },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.field, "name", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _vm.nameIsMissing
              ? _c("required-error-message", {
                  attrs: {
                    "field-name": _vm.resource(
                      "DivisionMiscellaneousFieldEditModel_Name_DisplayName"
                    )
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-4 mb-2" }, [
          _c(
            "label",
            {
              staticClass: "control-label",
              attrs: { for: _vm.idPrefix + "label", maxlength: "150" }
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.resource(
                      "DivisionMiscellaneousFieldEditModel_Label_DisplayName"
                    )
                  ) +
                  "\n                "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-8 mb-2" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.field.label,
                expression: "field.label"
              }
            ],
            staticClass: "form-control",
            attrs: { id: _vm.idPrefix + "label", type: "text" },
            domProps: { value: _vm.field.label },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.field, "label", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-4 mb-2" }, [
          _c(
            "label",
            {
              staticClass: "control-label",
              attrs: { for: _vm.idPrefix + "type" }
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.resource(
                      "DivisionMiscellaneousFieldEditModel_ValueType_DisplayName"
                    )
                  ) +
                  "\n                "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-8 mb-2" },
          [
            _c("dropdown", {
              attrs: {
                options: _vm.sortedTypeDropdownOptions,
                "text-field": "text",
                "value-field": "value",
                id: _vm.idPrefix + "type"
              },
              model: {
                value: _vm.field.valueType,
                callback: function($$v) {
                  _vm.$set(_vm.field, "valueType", $$v)
                },
                expression: "field.valueType"
              }
            }),
            _vm._v(" "),
            _vm.valueTypeIsMissing
              ? _c("required-error-message", {
                  attrs: {
                    "field-name": _vm.resource(
                      "DivisionMiscellaneousFieldEditModel_ValueType_DisplayName"
                    )
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-4 mb-2" }, [
          _c(
            "label",
            {
              staticClass: "control-label",
              attrs: { for: _vm.idPrefix + "jsonPath", maxlength: "150" }
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.resource(
                      "DivisionMiscellaneousFieldEditModel_JsonPath_DisplayName"
                    )
                  ) +
                  "\n                "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-8 mb-2" },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.field.jsonPath,
                  expression: "field.jsonPath"
                }
              ],
              staticClass: "form-control",
              attrs: { id: _vm.idPrefix + "jsonPath", type: "text" },
              domProps: { value: _vm.field.jsonPath },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.field, "jsonPath", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _vm.jsonPathIsMissing
              ? _c("required-error-message", {
                  attrs: {
                    "field-name": _vm.resource(
                      "DivisionMiscellaneousFieldEditModel_JsonPath_DisplayName"
                    )
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.jsonPathIsMissing ? _c("br") : _vm._e(),
            _vm._v(" "),
            !_vm.jsonPathIsValid
              ? _c("error-message", {
                  attrs: {
                    "field-name": _vm.resource(
                      "DivisionMiscellaneousFieldEditModel_JsonPath_DisplayName"
                    ),
                    message: _vm.resource(
                      "DivisionMiscellaneousFieldEditModel_JsonPath_InvalidPath_ErrorMessage"
                    )
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-4 mb-2" }, [
          _c(
            "label",
            {
              staticClass: "control-label",
              attrs: { for: _vm.idPrefix + "sortOrder" }
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.resource(
                      "DivisionMiscellaneousFieldEditModel_SortOrder_DisplayName"
                    )
                  ) +
                  "\n                "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-8 mb-2" },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.field.sortOrder,
                  expression: "field.sortOrder",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control",
              attrs: { id: _vm.idPrefix + "sortOrder", type: "number" },
              domProps: { value: _vm.field.sortOrder },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.field, "sortOrder", _vm._n($event.target.value))
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _vm.sortOrderIsMissing
              ? _c("required-error-message", {
                  attrs: {
                    "field-name": _vm.resource(
                      "DivisionMiscellaneousFieldEditModel_SortOrder_DisplayName"
                    )
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }